'use client';

import React, { useCallback, useState, useEffect } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';
import ErrorMessage from '@/components/common/ErrorMessage';

/**
 * Módulo Imprimir Contrato:
 * - estatus = "AUTORIZADO"
 * - Permite editar campos y ejecutar simulación SIAC
 * - Al actualizar fechaContratoImpreso, cambia automáticamente a "CONTRATO IMPRESO"
 */
const ImprimirContratoManagement: React.FC = () => {
  const [initialSolicitudes, setInitialSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchImprimirContrato = useCallback(async () => {
    setLoading(true);
    setError(null);
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      setError("No se pudo obtener el ID del usuario actual.");
      setLoading(false);
      return;
    }
    try {
      const response = await solicitudService.getImprimirContrato(currentUser.ownerID);
      if (response.data) {
        setInitialSolicitudes(response.data);
      } else {
        setError(response.error || "Error al cargar solicitudes de Imprimir Contrato.");
      }
    } catch (err: any) {
      setError(err.message || "Error de red al cargar solicitudes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchImprimirContrato();
  }, [fetchImprimirContrato]);

  if (loading) {
    return <div className="text-center py-4">Cargando solicitudes...</div>;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <SolicitudManagement
      fixedStatus="AUTORIZADO"
      title="Imprimir Contrato"
      modulo="imprimir-contrato"
      initialSolicitudes={initialSolicitudes}
      customFetch={fetchImprimirContrato}
      showNewButton={false}
      montoColumn="autorizado"
    />
  );
};

export default ImprimirContratoManagement;
